interface Action {
    type: string;
    updatedItem: any
}

export function reducer(state: any[], action: Action) {
    if (action.type === '') {


        // const updated = state?.map((el) =>
        //     (el?.propertyUsage?.toString() === (action.updatedItem as any)?.propertyUsage?.toString() &&
        //         el?.lvr?.toString() === (action.updatedItem as any)?.lvrRange?.toString() &&
        //         el?.repaymentType?.toString() === (action.updatedItem as any)?.repaymentType?.toString() &&
        //         el?.interestType?.toString() === (action.updatedItem as any)?.interestType?.toString()) ? 
        //         {...el, baseRate: (Number((action.updatedItem as any)?.basicInterestRate) -0.05)?.toFixed(2), borrowerRate: (+(Number((action.updatedItem as any)?.basicInterestRate) -0.05 -0.1 -Number(el.discount ?? 0))?.toFixed(2)) } : el
        //     );
        //     sessionStorage.setItem('rateFee', JSON.stringify(updated))
        return state;
    }
    throw Error('Unknown action.');
}